import { render, staticRenderFns } from "./UserMenuDropdownSidebar.vue?vue&type=template&id=d8e6c514&lang=pug"
import script from "./UserMenuDropdownSidebar.vue?vue&type=script&lang=js"
export * from "./UserMenuDropdownSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserMenuDropdownSidebar.vue?vue&type=style&index=0&id=d8e6c514&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports